import gsap from "gsap";
import { Clock } from "three";
import { Mesh } from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

import model from "../../assets/models/angelopolis_mapav12.glb";

export class GltfMapa extends Mesh {
  constructor(loadingManager) {
    super();
    this.allMesh = [];
    let loader = new GLTFLoader(loadingManager);
    this.clock = new Clock();
    this.onLoadModel(loader);
    this.scale.set(1, 1, 1);
    this.position.set(120, -8, -290);
    this.rotation.y += 0.03;
  }
  onLoadModel(loader) {
    loader.load(model, (gltf) => {
      gltf.scene.traverse((child) => {
        if (child.isMesh) {
          child.material.transparent = true;
          this.allMesh.push(child);
        }
      });
      this.onchangeVisibleModel(false);
      this.add(gltf.scene);
    });
  }
  onchangeVisibleModel(isVisible) {
    if (isVisible) {
      this.allMesh.map((mesh) => {
        gsap.to(mesh.material, {
          opacity: 1,
          duration: 1,
          onComplete: () => {
            // this.allModel.visible = false;
          },
        });
      });
    } else {
      this.allMesh.map((mesh) => {
        gsap.to(mesh.material, {
          opacity: 0,
          duration: 1,
          onComplete: () => {
            // this.allModel.visible = false;
          },
        });
      });
    }
  }

  renderAnimations() {}
}
